import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { css } from 'styled-components';

// Other controls
import { Hint } from '@independent-software/typeui/controls/Form/Hint';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  /** Label to show above value */
  label: string;
  /** Unit to show. Can be JSX. */
  unit?: React.ReactNode;
  /** Optional flex width */
  width?: number;
  /** Optional hint text. Can be JSX. */
  hint?: React.ReactNode;
  /** If true, show no background and add no padding. */
  nobackground?: boolean;
}

const TextLabel = styled.div`
  position: relative;
  font-weight: 500;
  font-size: 80%;
  margin-right: 1em;
  /* Ordinarily, labels are displayed above the field control: */
  display: block;
`

const Block = styled.div`
`

const Unit = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  background: #ddd;
  height: 38px;
  line-height: 38px;
  &:before {
    content: '';
    position: absolute;
    width: 0.6em;
    height: 0.6em;
    border-style: inherit;
    border-color: inherit;
    background: inherit;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);  
    top: 50%;
    border-width: 0 0 1px 1px;    
  }
  margin-left: 1em;
`

const UnitSpacer = styled.div`
  padding: 0 10px 0 10px;
`

const OutputBase = (props: IProps) => {
  // Does the label have content?
  let hasContent = React.Children.count(props.children) != 0;

  return (
    <div className={props.className}>
      <TextLabel>{props.label}</TextLabel>
      <Block>
        {!hasContent ? '-' : props.children}&nbsp;
        {props.unit && 
        <Unit>
          <UnitSpacer>
            {props.unit}
          </UnitSpacer>
        </Unit>}          
      </Block>
      {props.hint && <Hint>{props.hint}</Hint>}
    </div>
  );
}

const OutputStyled = styled(OutputBase)`
  padding-bottom: 8px;

  /* Fields may provide their width in relative units to other fields. */
  ${(p:any) => p.width && css `flex: ${p.width}`}

  ${Block} {
    position: relative;
    background: #f6f6f6;
    padding: 7px 10px 7px 10px;
    ${p => p.nobackground && css`
      background: transparent;
      padding: 4px 0px 4px 0px;
    `}
  }
`

const Output = (props: IProps) => <OutputStyled {...props}></OutputStyled>

export { Output }
